var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled, { ThemeProvider } from "styled-components";
import MainTheme from "@irati/ui/src/global/theme";
import padding from "@irati/ui/src/global/padding";
import { twoPxShadowBigBlur } from "@irati/ui/src/global/elevation";
export var OverlayPlacement;
(function (OverlayPlacement) {
    OverlayPlacement["Right"] = "right";
    OverlayPlacement["Left"] = "left";
    OverlayPlacement["Bottom"] = "bottom";
    OverlayPlacement["Top"] = "top";
})(OverlayPlacement || (OverlayPlacement = {}));
var StyledOverlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"
    // This component is being rendered by react-bootstrap OverlayTrigger component.
    // It looks like it's not giving it access to the main theme provider so we are providing it again.
])), function (_a) {
    var theme = _a.theme, placement = _a.placement;
    return "\n    position: absolute;\n    background-color: " + theme.colors.greys.white + ";\n    padding: " + padding.tiny + ";\n    border-radius: 2px;\n    max-width: 250px;\n    z-index: 99999;\n    " + twoPxShadowBigBlur + "\n\n    " + (placement === OverlayPlacement.Right && "transform: translate3d(10px, 0, 0);") + "\n    " + (placement === OverlayPlacement.Left && "transform: translate3d(-10px, 0, 0);") + "\n    " + (placement === OverlayPlacement.Bottom && "transform: translate3d(0, 10px, 0);") + "\n    " + (placement === OverlayPlacement.Top && "transform: translate3d(0, -10px, 0);") + "\n\n    :before {\n      border: solid transparent;\n      content: \" \";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border-width: 7px;\n\n      " + (placement === OverlayPlacement.Right &&
        "\n        top: 50%;\n        right: 100%;\n        margin-top: -7px;\n        border-right-color: " + theme.colors.greys.white + ";\n      ") + "\n      " + (placement === OverlayPlacement.Left &&
        "\n        top: 50%;\n        left: 100%;\n        margin-top: -7px;\n        border-left-color: " + theme.colors.greys.white + ";\n      ") + "\n      " + (placement === OverlayPlacement.Bottom &&
        "\n        bottom: 100%;\n        left: 50%;\n        margin-left: -7px;\n        border-bottom-color: " + theme.colors.greys.white + ";\n      ") + "\n      " + (placement === OverlayPlacement.Top &&
        "\n        top: 100%;\n        left: 50%;\n        margin-left: -7px;\n        border-top-color: " + theme.colors.greys.white + ";\n      ") + "\n    }\n  ";
});
// This component is being rendered by react-bootstrap OverlayTrigger component.
// It looks like it's not giving it access to the main theme provider so we are providing it again.
var Overlay = function (props) {
    return (React.createElement(ThemeProvider, { theme: MainTheme },
        React.createElement(StyledOverlay, __assign({}, props))));
};
export default Overlay;
var templateObject_1;
